module.exports = __webpack_public_path__ + "img/FullRedCol.014e9189.jpg";